import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  CheckCircle,
  ClockIcon,
  XCircle,
  Mic,
  Headphones,
  Clock,
  CalendarIcon,
  ArrowDown,
  ArrowUp,
  PlayCircle,
} from "lucide-react";
import { AnimatePresence,motion } from "framer-motion";
import { getPodcastsClient, setPodcast } from "../../../../slices/clientesSlice";



export default function Account() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { eventos } = useSelector((state) => state.evento);
  const { stadistics } = useSelector((state) => state.podcast);
  const { podcasts } = useSelector(state => state.clientes)
  const { podcast } = useSelector(state => state.clientes)

  const proximosEventos = eventos.slice(0, 2);

  const handleModal = (podcast) => {
    dispatch(setPodcast(podcast));
    navigate(`/client/podcast/${podcast.nombre}`);
  };

  const podcastList = podcasts || [];

  useEffect(() => {
    dispatch(getPodcastsClient())
  },[dispatch])

  return (
    <AnimatePresence>
    <motion.div
      initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        exit={{ opacity: 0, y: -20 }} 
        transition={{ duration: 1.4 }} 
      className="w-full bg-gray-50 min-h-screen dark:bg-background px-4 sm:px-10 font-poppina"
    > 
      <div className="mt-2 text-gray-500">
        <p>Cuenta</p>
      </div>

      <div className="podcast -z-10 mb-10 mt-5">
        <div>
          <h1 className="text-2xl text-text sm:text-4xl font-semibold">Hola! Rodrigo Silva</h1>
        </div>
      </div>

      <div className="contenedor-stats w-full gap-x-8 my-5 rounded-lg flex flex-col sm:flex-row gap-4">
        <div className="w-full bg-card hover:scale-105 transition-all ease-in-out sm:w-[390px] h-[110px] shadow-md p-3 rounded-lg ">
          <div className="flex justify-between">
            <div className="ml-4">
              <p className="text-subtitle sm:tex-base text-sm  ">Podcast transmitidos en la semana</p>
              <p className="text-2xl font-bold text-text">{stadistics?.transmitidosWeek || "N/A"}</p>
            </div>
            <div className="p-3 w-12 h-12 bg-blue-100 rounded-full">
              <Mic className="w-6 h-6 text-blue-500" />
            </div>
          </div>

          <div className="flex ml-3 items-center">
            <ArrowUp className="text-green-500 w-5 h-5" />
            <p className="text-green-400">3.48%</p>
          </div>
        </div>

        <div className="w-full bg-card hover:scale-105 transition-all ease-in-out sm:w-[390px] h-[110px] shadow-md p-3 rounded-lg">
          <div className="flex justify-between">
            <div className="ml-4">
              <p className="text-subtitle  ">Total de podcast emitidos</p>
              <p className="text-2xl font-bold text-text">{stadistics?.totalPodcasts || "N/A"}</p>
            </div>
            <div className="p-3 w-12 h-12 bg-green-100 rounded-full">
              <Headphones className="w-6 h-6 text-green-500" />
            </div>
          </div>

          <div className="flex ml-3 items-center">
            <ArrowDown className="text-red-500 w-5 h-5" />
            <p className="text-red-400">1.26%</p>
          </div>
        </div>

        <div className="w-full bg-card hover:scale-105 transition-all ease-in-out sm:w-[390px] h-[110px] shadow-md p-3 rounded-lg">
          <div className="flex justify-between">
            <div className="ml-4">
              <p className="text-subtitle">Horas emitidas</p>
              <p className="text-2xl font-bold text-text">{stadistics?.horas || "N/A"}</p>
            </div>
            <div className="p-3 w-12 h-12 bg-purple-100 rounded-full">
              <Clock className="w-6 h-6 text-purple-500" />
            </div>
          </div>

          <div className="flex ml-3 items-center">
            <ArrowDown className="text-red-500 w-5 h-5" />
            <p className="text-red-400">0.72%</p>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <h1 className="text-text font-semibold text-2xl sm:text-4xl">
          Mis podcast
        </h1>
      </div>

      <div className="flex flex-wrap mt-5 gap-4 sm:gap-6 w-full">
      {podcastList.length > 0 ? (
  podcastList.map((podcast, index) => (
    <div
      key={index}
      onClick={() => handleModal(podcast)} 
      className="bg-card relative flex flex-col justify-between border cursor-pointer dark:border-none border-gray-200 w-full sm:w-[400px] min-h-[200px] rounded-lg shadow-sm hover:shadow-lg hover:border-blue-400 hover:border hover:scale-105 transition-all duration-300 overflow-hidden"
    >
      
      

      <div className="absolute inset-0 bg-gradient-to-tr from-blue-50 to-blue-100 dark:opacity-0 opacity-50 z-0"></div>
      <div className="absolute bottom-0 right-0 w-24 h-24 bg-blue-200 rounded-full transform translate-x-1/2 translate-y-1/2 dark:opacity-0 opacity-20 z-0"></div>

      <div className="p-4 relative ">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-blue-100 rounded-full">
            <PlayCircle className="w-6 h-6 text-blue-500" />
          </div>
          <h1 className="text-xl sm:text-2xl text-text font-bold">
            {podcast.name}
          </h1>
        </div>
        <p className="text-xs sm:text-sm text-gray-700 mt-2">
          {podcast.description}
        </p>
      </div>
    </div>
  ))
) : (
  <div>
    <h1>Aun no tienes podcasts</h1>
  </div>
)}
      </div>

      <div className="mt-10 shadow p-3 bg-background rounded-lg font-poppina mx-auto">
        <h1 className="text-2xl sm:text-3xl font-semibold text-text mb-6">
          Próximos eventos
        </h1>
        <div className="space-y-4">
          {eventos && eventos.length > 0 ? (
            proximosEventos.map((podcast) => (
              <div
                key={podcast.id}
                className="bg-card relative border border-border rounded-lg shadow-lg p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center sm:space-x-6 hover:shadow-xl transition-shadow duration-300"
              >
                <div
                  className={`p-2 sm:p-3 ${podcast.iconBg} rounded-full mb-4 sm:mb-0`}
                >
                  <Headphones
                    className={`w-5 h-5 sm:w-6 sm:h-6 ${podcast.iconColor}`}
                  />
                </div>
                <div className="flex-1">
                  <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">
                    {podcast.title}
                  </h2>
                  <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 text-subtitle">
                    <div className="flex items-center space-x-2 mb-2 sm:mb-0">
                      <CalendarIcon className="w-4 h-4" />
                      <p>{podcast.date}</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Clock className="w-4 h-4" />
                      <p>{podcast.time}</p>
                    </div>
                  </div>
                  <p className="text-sm text-subtitle mt-2">
                    Plataforma: {podcast.platform}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-text">
              <h1 className="text-xl">No hay eventos...</h1>
              <p className="text-subtitle">Agenda una cita en tus podcasts disponibles</p>
            </div>
          )}
        </div>
      </div>
    </motion.div>
    </AnimatePresence>
  );
}